'use client';

export { default } from './Stack';
export { default as stackClasses } from './stackClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Stack/index.js
// module id = 524
// module chunks = 25